<template>
  <div class="celebration-inner-wrapper">
    
    <div class="icon-circle mb-3">
        <img
          src="https://cdn-icons-png.flaticon.com/512/3159/3159066.png"
          alt="celebration"
        />
    </div>
    <!-- Celebration Icon -->
    <h2 class="celebration-title">{{ celebrationTitle }}</h2>

    <div v-if="celebrationBadge" class="celebration-badge my-3">
        {{ celebrationBadge }}
    </div>

    <p class="text-white mb-3">
        {{ celebrationMessage }}
    </p>

    <!-- <div class="auto-close">
        ✨ Auto-closing in {{ countdownSeconds }}s ✨
    </div> -->
  </div>
</template>
<script>
import { axiosGet } from "../../../common/Helper/AxiosHelper";
import { PUBLIC_DASHBOARD } from "../../../tenant/Config/ApiUrl";

export default {
  name: "CelebrationPopup",
  data() {
    return {
      // UI auto-close in seconds
      countdownSeconds: 5,
      uiTimer: null,

      // Data from API
      celebrationTitle: "🎉 CELEBRATION! 🎉",
      celebrationBadge: "",
      celebrationMessage: "Enjoy the celebration with the team!",

      // refresh timer for API polling
      refreshInterval: null,
    };
  },
  mounted() {
    // Fetch celebration data and start refresh + auto-close timers
    this.fetchCelebrationData();
    this.startDataRefresh();
    this.startCountdown();
  },
  methods: {
    fetchCelebrationData() {
      axiosGet(`${PUBLIC_DASHBOARD}/calendar-events`).then(({ data }) => {
        // Prefer birthdays/anniversaries happening today
        const todayBirthday = (data.birthdays || []).find(b => b.day === 'Today');
        const todayAnniv = (data.anniversaries || []).find(a => a.day === 'Today');

        if (todayBirthday) {
          this.celebrationTitle = `🎂 Happy Birthday ${todayBirthday.name}`;
          this.celebrationBadge = 'Birthday';
          this.celebrationMessage = `Wish ${todayBirthday.name} a great day!`;
        } else if (todayAnniv) {
          this.celebrationTitle = `🎉 Happy ${todayAnniv.years} Year(s) ${todayAnniv.name}`;
          this.celebrationBadge = 'Anniversary';
          this.celebrationMessage = `${todayAnniv.name} has been with ADITI for ${todayAnniv.years} year(s)`;
        } else if (data.countdown && data.countdown.title && data.countdown.title !== 'No upcoming events' && data.countdown.days === 0) {
          this.celebrationTitle = `🎉 ${data.countdown.title} 🎉`;
          this.celebrationBadge = 'Today';
          this.celebrationMessage = `${data.countdown.title} is happening today!`;
        } else {
          // No relevant events - close the popup
          this.$emit('close');
          return;
        }
      }).catch(() => {
        // keep existing fallback UI on error
      });
    },

    startDataRefresh() {
      if (this.refreshInterval) clearInterval(this.refreshInterval);
      // Refresh every 60 seconds
      this.refreshInterval = setInterval(() => {
        this.fetchCelebrationData();
      }, 60 * 1000);
    },

    startCountdown() {
      this.countdownSeconds = 5;
      if (this.uiTimer) clearInterval(this.uiTimer);

      this.uiTimer = setInterval(() => {
        this.countdownSeconds--;
        if (this.countdownSeconds <= 0) {
          clearInterval(this.uiTimer);
          this.$emit('close');
        }
      }, 1000);
    },

  },
  beforeDestroy() {
    // Vue 2 lifecycle hook (project uses Vue 2 elsewhere)
    if (this.uiTimer) clearInterval(this.uiTimer);
    if (this.refreshInterval) clearInterval(this.refreshInterval);
  },
  beforeUnmount() {
    // Vue 3 lifecycle hook (safe to keep if project upgrades)
    if (this.uiTimer) clearInterval(this.uiTimer);
    if (this.refreshInterval) clearInterval(this.refreshInterval);
  }
};
</script>

<style scoped>
/* Removed .celebration-overlay as parent handles it */
/* Removed .celebration-card styles that conflict with parent */

.celebration-inner-wrapper {
  position: relative;
  /* Ensure content is visible and styled appropriately */
  color: white;
  /* animation: celebration-pop-float 3s ease-in-out infinite; */
}

/* @keyframes celebration-pop-float {
  0% {
    transform: translateY(0) scale(1) rotate(0deg);
  }
  25% {
    transform: translateY(-15px) scale(1.02) rotate(2deg);
  }
  50% {
    transform: translateY(0) scale(1) rotate(0deg);
  }
  75% {
    transform: translateY(10px) scale(0.98) rotate(-2deg);
  }
  100% {
    transform: translateY(0) scale(1) rotate(0deg);
  }
} */

.icon-circle {
  width: 90px;
  height: 90px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-circle img { width: 45px; }
.celebration-title { color: #fff; font-weight: 800; letter-spacing: 2px; }
.celebration-badge {
  background: #fff; color: #b02a37; padding: 12px 28px; border-radius: 14px; font-size: 20px; font-weight: 700;
  display: inline-block; /* Fix for badge */
}
.auto-close {
  margin-top: 12px; background: rgba(0,0,0,0.25); color: #fff; padding: 8px 16px; border-radius: 20px; font-size: 14px;
  display: inline-block;
}


</style>
